import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=2486b4d2&scoped=true&"
import script from "./PortalLogin.vue?vue&type=script&lang=js&"
export * from "./PortalLogin.vue?vue&type=script&lang=js&"
import style0 from "./PortalLogin.vue?vue&type=style&index=0&id=2486b4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486b4d2",
  null
  
)

export default component.exports